import React from 'react';
import { createSubcomponent } from '@workday/canvas-kit-react/common';
import { Avatar } from '@workday/canvas-kit-react/avatar';
import { usePillModel } from './usePillModel';
// When the component is created, it needs to be a button element to match AvatarProps.
// Once Avatar becomes a `createComponent` we can default the element type to a `div`
// and the types should be properly extracted
export const PillAvatar = createSubcomponent('button')({
    modelHook: usePillModel,
})((elemProps, Element, model) => {
    return (React.createElement(Avatar, Object.assign({ style: { opacity: model.state.disabled ? '.7' : '1' }, as: "div", size: 18, altText: undefined }, elemProps, { disabled: model.state.disabled }), elemProps.children));
});
